import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const req = (path, method = "GET", body) => fetch(`${API}/api${path}`, { method, credentials: "include", headers: { "Content-Type": "application/json" }, body: body && JSON.stringify(body) })
  .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`Request failed (${r.status})`))));

export const NetworkLaunchCard = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");
  const load = () => req("/admin/network-outreach/status").then(setS).catch((e) => setMsg(e.message));
  useEffect(() => { load(); }, []);

  const toggle = async () => {
    const goLive = s.live_status === "sandbox";
    if (!window.confirm(goLive ? "Go LIVE? Real invites and texts will reach real vendors." : "Switch to TEST mode? Messages go to the test inbox only.")) return;
    setBusy("mode");
    try { await req("/admin/runtime-config", "POST", { sandbox_mode_override: !goLive }); await load(); } catch (e) { setMsg(e.message); } finally { setBusy(""); }
  };
  const runNow = async () => {
    if (!window.confirm(`Send today's batch now? Up to ${s.daily_max} approved prospects, ${s.live_status === "live" ? "LIVE" : "test mode"}.`)) return;
    setBusy("run");
    try { const r = await req("/admin/network-outreach/run", "POST"); setMsg(`Batch done · ${r.dispatched} invites sent`); await load(); } catch (e) { setMsg(e.message); } finally { setBusy(""); }
  };

  if (!s) return <div className="rr-muted" data-testid="network-launch-loading">{msg || "Loading network launch status…"}</div>;
  const live = s.live_status === "live";
  return (
    <div className="nl-card" data-testid="network-launch-card">
      <div className="nl-top">
        <div>
          <div className="rr-eyebrow">Network Build & Warm Onboarding</div>
          <div className="nl-mode" data-testid="network-launch-mode"><span className={`nl-dot ${live ? "on" : ""}`} />{live ? "LIVE · real vendors receive invites" : "TEST MODE · messages go to the test inbox"}</div>
          <div className="rr-muted nl-sub" data-testid="network-launch-schedule">
            {s.live_launch_done_at ? `Went live ${new Date(s.live_launch_done_at).toLocaleString()}` : s.auto_live_launch_armed ? "Auto go-live armed · next 3:00 PM Central run" : "Auto go-live off"} · daily batch {s.launch_time}
          </div>
        </div>
        <div className="nl-actions">
          <button type="button" onClick={toggle} disabled={!!busy} className={live ? "nl-btn" : "nl-btn nl-btn--go"} data-testid="network-launch-toggle">{busy === "mode" ? "Switching…" : live ? "Switch to test mode" : "Go live now"}</button>
          <button type="button" onClick={runNow} disabled={!!busy} className="nl-btn" data-testid="network-launch-run-now">{busy === "run" ? "Sending…" : "Send today's batch now"}</button>
        </div>
      </div>
      <div className="nl-stats">
        <div data-testid="network-sent-24h"><b>{s.sent_last_24h}</b><span>sent (24h) · target {s.daily_min}–{s.daily_max}</span></div>
        <div data-testid="network-approved-waiting"><b>{s.approved_waiting}</b><span>approved prospects waiting</span></div>
        <div data-testid="network-pending-review"><b>{s.pending_review}</b><span>awaiting your review</span></div>
        <div data-testid="network-intakes-24h"><b>{s.intakes_24h}</b><span>new intakes (24h)</span></div>
        <div data-testid="network-courier-capable"><b>{s.courier_capable}</b><span>courier-capable partners</span></div>
      </div>
      {s.welcome_calls_pending.length > 0 && (
        <div className="nl-calls" data-testid="network-welcome-calls">
          <b>Welcome calls to make ({s.welcome_calls_pending.length})</b>
          {s.welcome_calls_pending.slice(0, 8).map((c) => (
            <a key={c.partner_id} href={`tel:${c.contact_phone}`} data-testid={`network-call-${c.partner_id}`}>{c.contact_name} · {c.trade}{c.courier_eligible ? " · hauls" : ""} · {c.contact_phone}</a>
          ))}
        </div>
      )}
      {s.trade_gaps.length > 0 && <div className="rr-muted nl-sub" data-testid="network-trade-gaps">No approved partner yet in: {s.trade_gaps.join(", ")}</div>}
      {msg && <div className="rr-muted nl-sub" data-testid="network-launch-msg">{msg}</div>}
    </div>
  );
};
